import { Filter as CommonFilter, FilterProps } from '@otp/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { getFilterConfig } from './config';
import { useTags } from 'src/hooks/query/use-tags';
import { TagEntityType } from 'src/graphql/generated/graphql';

export const Filter = (props: Omit<FilterProps, 'items'>) => {
  const { t } = useTranslation();

  const { tags } = useTags({
    filter: { entityType: TagEntityType.Role },
  });

  const filterConfig = getFilterConfig({ t, tags });

  return (
    <CommonFilter
      {...props}
      items={filterConfig}
      searchInputProps={{
        placeholder: t('roles.list.filter.search.placeholder'),
      }}
    />
  );
};
